import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';
import { IntlMessages } from '../../../util';
import { RetrieveFlightBatchUpdateResponse } from '../../../models';
import { TFFDialog } from '../../../styled-components/TFFDialog';
import TFFTypography from '../../../styled-components/TFFTypography';
import { useIntl } from 'react-intl';

interface UpdateResultDialogProps {
  open: boolean;
  onClose: () => void;
  response: RetrieveFlightBatchUpdateResponse;
}

export const UpdateResultDialog: React.FC<UpdateResultDialogProps> = ({ open, onClose, response }) => {
  const intl = useIntl();

  const hasFailures = response.FailedPnrs?.length > 0;
  const hasSuccesses = response.UpdatedPnrs?.length > 0;

  return (
    <TFFDialog
      dialogId="pnr-update-result-dialog"
      isOpen={open}
      header={
        <TFFTypography
          text={intl.formatMessage({ id: 'pnr.update.result.title' }).toUpperCase()}
          variant="lead"
          size="large"
          fontWeight="bold"
        />
      }
      onCancel={onClose}
      closeButton
    >
      {response.Status === 'FAILURE' && response.Error && (
        <Typography color="error" gutterBottom>
          <IntlMessages id="pnr.update.error" />: {response.Error}
        </Typography>
      )}

      {hasSuccesses && (
        <>
          <Typography variant="h6" color="success.main" gutterBottom>
            <IntlMessages id="pnr.update.success.title" /> ({response.UpdatedPnrs!.length})
          </Typography>
          <List dense>
            {response.UpdatedPnrs!.map(pnr => (
              <ListItem key={pnr}>
                <ListItemText primary={pnr} />
              </ListItem>
            ))}
          </List>
        </>
      )}

      {hasFailures && (
        <>
          <Typography variant="h6" color="error" gutterBottom>
            <IntlMessages id="pnr.update.failure.title" /> ({response.FailedPnrs!.length})
          </Typography>
          <List dense>
            {response.FailedPnrs!.map(pnr => (
              <ListItem key={pnr}>
                <ListItemText primary={pnr} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </TFFDialog>
  );
};
